module.exports = __webpack_public_path__ + "img/3x.d9e9047.jpg";